import React from "react";
import { Outlet } from "react-router-dom";

import Notification from "./shared/Notification";

// Jazyk sa nastavuje pri štarte (src/index.js) a po prihlásení z účtu (AuthProvider) — src/services/language.js
const Layout = () => {
    return (
        <main className="App">
            <Notification />
            <Outlet/>
        </main>
    )
}

export default Layout;
